// extracted by mini-css-extract-plugin
export default {"action-button":"delete-card_action-button__15rLh"};